import styled from "@emotion/styled";
export const StyledAutomationsComponent = styled.div`
  max-width: 720px;

  .automation-image {
    height: auto;
    width: 100%;
    margin-bottom: 16px;
  }
`;
